<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/ai/data_service/banner.png')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">千智数据平台</div>
          <div class="title-2">让数据驱动智能，整合全链路数据能力<br>
            构建高效、安全、一站式的模型训练与业务赋能环境</div>
          <div class="title-3" @click="openContactUs">
            申请试用
          </div>
        </div>
      </div>

    </div>

    <!-- 核心能力 -->
    <div class="capability-section" data-aos="fade-up">
      <div class="section-title">核心能力</div>
      <div class="capability-grid">
        <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
          <img class="capability-icon" :src="item.icon" alt="">
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 数据流转 -->
    <div class="flow-section" data-aos="fade-up">
      <div class="section-title" style="margin-bottom: 10px;">数据流转可视化</div>
      <div class="section-subtitle">全流程可视化追踪，从数据接入到智能应用的完整链路，清晰可见，高效可控</div>
      <img style="width: 1200px;height: 530px;margin-top: 40px;" src="@/assets/product/ai/data_service/img1.png" />
    </div>


    <!-- 技术特点 -->
    <div class="feature-section" data-aos="fade-up"
      :style="{ backgroundImage: `url(${require('@/assets/product/ai/data_service/banner1.png')})` }">
      <div class="section-title" style="color:#FFFFFF;margin-bottom: 12px;">技术特点</div>
      <div class="section-subtitle" style="color:#FFFFFF;margin-bottom: 20px;">全链路高效、安全、可扩展的智能数据底座</div>
      <div class="feature-grid">
        <div class="feature-card" v-for="(item, index) in featureList" :key="index">
          <img class="feature-icon" :src="item.icon"></img>
          <div class="feature-name">{{ item.name }}</div>
          <div class="feature-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <!-- <div class="scene-section">
      <div class="section-title">应用场景</div>
      <div class="scene-grid">
        <div class="scene-card" v-for="(item, index) in sceneList" :key="index">
          <div class="scene-icon">{{ item.icon }}</div>
          <div class="scene-name">{{ item.name }}</div>
          <div class="scene-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div> -->

    <div class="flor3" data-aos="fade-up">
      <div class="f2-title">应用场景</div>
      <div class="f2-subtitle">覆盖多元行业场景，以数据智能驱动业务创新与增长</div>

      <div class="scene-cards-container">
        <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
          <div class="f3-card"
            :style="{ backgroundImage: `url(${scene.icon})` }">
            <div class="title">{{ scene.name }}</div>
            <div class="subtitle">{{ scene.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.aiDataService,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/ai/data_service/icon1.png"), name: '数据接入', desc: '支持 API、文件上传、数据库同步等多种数据接入方式' },
        { icon: require("@/assets/product/ai/data_service/icon2.png"), name: '数据清洗', desc: '自动去重、标注、增强，提升数据质量' },
        { icon: require("@/assets/product/ai/data_service/icon3.png"), name: '数据服务', desc: '提供高效的数据处理与模型训练环境' },
        { icon: require("@/assets/product/ai/data_service/icon4.png"), name: '模型训练', desc: '一键式模型训练，快速构建 AI 能力' },
        { icon: require("@/assets/product/ai/data_service/icon5.png"), name: '数据分析', desc: '可视化数据分析，洞察数据价值' },
        { icon: require("@/assets/product/ai/data_service/icon6.png"), name: '快速部署', desc: '一键部署上线，快速验证效果' }
      ],
      flowList: [
        { icon: '📤', name: '数据上传', desc: '支持多种格式' },
        { icon: '🔧', name: '数据处理', desc: '清洗、标注、增强' },
        { icon: '🎯', name: '模型训练', desc: '高效训练环境' },
        { icon: '✅', name: '模型部署', desc: '一键上线' }
      ],
      processList: [
        { icon: '📥', title: '数据上传', desc: '支持 CSV、JSON、Excel、图片、视频等多种格式，可通过 API 实时接入、文件批量上传或数据库直连同步。系统自动识别数据类型和结构，为后续处理做好准备。' },
        { icon: '🧹', title: '数据清洗与标注', desc: 'AI 自动检测并处理缺失值、异常值和重复数据。支持智能标注功能，可根据业务需求自动打标签，大幅提升数据准备效率。' },
        { icon: '🎓', title: '模型训练', desc: '提供可视化训练界面，支持分布式训练加速。自动超参数调优，降低模型开发门槛。训练过程实时监控，异常自动告警。' },
        { icon: '🚀', title: '模型部署', desc: '一键式部署到云端或边缘设备。支持多版本管理、A/B 测试和灰度发布。提供 API 接口，快速集成到业务系统。' }
      ],
      featureList: [
        { icon: require("@/assets/product/ai/data_service/icon7.png"), name: '多源数据接入', desc: '支持 API、数据库、文件等多类型数据统一接入，实现数据集中管理' },
        { icon: require("@/assets/product/ai/data_service/icon8.png"), name: '高效处理', desc: '分布式计算架构，提升数据处理与训练效率，加速业务响应速度' },
        { icon: require("@/assets/product/ai/data_service/icon9.png"), name: '数据安全', desc: '企业级安全防护体系，全程数据加密存储，保障数据隐私与合规性' },
        { icon: require("@/assets/product/ai/data_service/icon10.png"), name: '弹性扩展', desc: '可按需扩容，灵活适配业务增长与模型迭代需求，支撑业务快速发展' }
      ],
      sceneList: [
        { icon: require("@/assets/product/ai/data_service/img2.png"), name: '企业 AI 中台', desc: '构建企业级统一 AI 能力底座，整合多源数据、算法模型与算力资源，实现数据标准化、模型复用化与服务 API 化，助力企业快速搭建，加速数字化转型与业务创新。' },
        { icon: require("@/assets/product/ai/data_service/img4.png"), name: '智能零售', desc: '深度分析用户行为与消费偏好，支撑精准营销、智能推荐与客流分析，同时赋能门店智能巡检与库存优化，全面提升用户体验、运营效率与营收转化。' },
        { icon: require("@/assets/product/ai/data_service/img3.png"), name: '智慧医疗', desc: '实现医疗数据标准化治理与安全共享，辅助临床诊断、健康风险预警与医疗资源调度，提升诊疗精准度与服务效率，助力医疗机构智能化升级。' },
        { icon: require("@/assets/product/ai/data_service/img5.png"), name: '智能制造', desc: '采集并分析生产全链路数据，实现设备预测性维护、质量异常检测与产能优化，降低生产损耗，提升产线稳定性与合格率，推动工厂向智能化、精益化转型。' }
      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', '千智数据平台')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #7C3AED;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #F5F3FF;
    transform: translateY(-2px);
  }
}

.btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: transparent;
  border: 2px solid #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* 数据流转 */
.flow-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #fff;
}

.flow-container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flow-step {
  flex: 1;
  text-align: center;
  position: relative;
}

.flow-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin: 0 auto 16px;
}

.flow-name {
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 8px;
}

.flow-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.flow-arrow {
  position: absolute;
  right: -10px;
  top: 30px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);
}

/* 数据流程详情 */
.process-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.process-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.process-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 32px;
}

.process-icon {
  font-size: 36px;
  margin-bottom: 16px;
}

.process-title {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 12px;
}

.process-desc {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
}

/* 技术特点 */
.feature-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #FFFFFF;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}

.feature-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  background: #F5F3FF;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
}

.feature-icon {
  font-size: 36px;
  margin-bottom: 16px;
  width: 40px;
  height: 40px;
}

.feature-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 22px;
  text-align: center;
}

.feature-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #595859;
  line-height: 20px;
  text-align: center;
}

/* 应用场景 */
.scene-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.scene-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.scene-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.scene-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.scene-name {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.scene-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* CTA 区域 */
.cta-section {
  width: 100%;
  min-width: 1200px;
  padding: 100px 0;
  background: #FFFFFF;
  text-align: center;
}

.cta-title {
  font-weight: bold;
  font-size: 36px;
  color: #222222;
  margin-bottom: 20px;
}

.cta-desc {
  font-size: 18px;
  color: #666666;
  margin-bottom: 40px;
}

.flor3 {
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  background: #F4F5FB;
  flex-direction: column;
  padding-bottom: 80px;

  .f2-title {
    margin-top: 80px;
    margin-bottom: 35px;
    height: 34px;
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }

  .f2-subtitle {
    height: 60px;
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }

  .scene-cards-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 40px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .f3-card {
    width: 100%;
    height: 100%;
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding: 275px 20px 20px 20px;
    box-sizing: border-box;

    .title {
      margin-bottom: 27px;
      font-weight: bold;
      font-size: 22px;
      color: #222222;
      line-height: 22px;
      text-align: left;
    }

    .subtitle {
      font-size: 14px;
      color: #222222;
      line-height: 22px;
      text-align: justify;
    }
  }

}
</style>
